import { useEffect, useState } from "react";
import { adminApi, type TeacherInfo } from "@/services/api/admin";
import { useTalkT } from "./useTalkT";
import { talkRadarStageStyle } from "./talkRadarStage";

export function TalkRadarAssign({
  requestId,
  lessonId,
  assignedTeacherName,
  onAssigned,
}: {
  requestId: string;
  lessonId: string;
  assignedTeacherName?: string | null;
  onAssigned: () => void;
}) {
  const t = useTalkT();
  const [query, setQuery] = useState("");
  const [teachers, setTeachers] = useState<TeacherInfo[]>([]);
  const [error, setError] = useState<string | null>(null);
  const [pendingTeacherId, setPendingTeacherId] = useState<string | null>(null);

  useEffect(() => {
    const search = query.trim();
    if (!search) {
      setTeachers([]);
      return;
    }
    let live = true;
    adminApi
      .listTeachers({ search, limit: 10 })
      .then((res) => {
        if (live) setTeachers(res.teachers || []);
      })
      .catch(() => {
        if (live) setTeachers([]);
      });
    return () => {
      live = false;
    };
  }, [query]);

  async function assign(teacherId: string) {
    setError(null);
    try {
      await adminApi.assignSubstitution(requestId, teacherId, [lessonId]);
      onAssigned();
    } catch (err: unknown) {
      setError(err instanceof Error ? err.message : t("talk_radar_assign_failed"));
    }
  }

  function choose(teacherId: string) {
    if (assignedTeacherName) {
      setPendingTeacherId(teacherId);
      return;
    }
    void assign(teacherId);
  }

  return (
    <div
      className="talk-radar-assign"
      style={{ ...talkRadarStageStyle, zIndex: 3 }}
    >
      <h2>{t("talk_radar_assign")}</h2>
      <input
        aria-label={t("talk_radar_teacher")}
        value={query}
        onChange={(event) => setQuery(event.target.value)}
      />
      {error && <p>{error}</p>}
      {pendingTeacherId && (
        <section>
          <p>{t("talk_radar_overwrite", { name: assignedTeacherName })}</p>
          <button type="button" onClick={() => void assign(pendingTeacherId)}>
            {t("talk_radar_overwrite_action")}
          </button>
          <button type="button" onClick={() => setPendingTeacherId(null)}>
            {t("talk_radar_cancel")}
          </button>
        </section>
      )}
      <ul>
        {teachers.map((teacher) => (
          <li key={teacher.id}>
            <button type="button" onClick={() => choose(teacher.id)}>
              {teacher.first_name} {teacher.last_name}
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
}
